module.exports = __webpack_public_path__ + "0dac25e249518ad3358093e93e8ae0a1.svg";